// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p1-0";
export var discountCodeInput = "_p1-1";